const UserType = {
  USER: "user",
  ADMIN: "admin",
};

export default UserType;
